import AsyncStorage from '@react-native-async-storage/async-storage';

import { CONTENTFUL_CACHE_STORAGE_KEY } from '../../contentful-content-type-entries-machine.constants';

/**
 * Removes Contentful cache entries that older app versions kept in AsyncStorage.
 */
export async function removeLegacyCacheEntries() {
  try {
    const storageKeys = await AsyncStorage.getAllKeys();
    const legacyCacheEntries = storageKeys.filter(checkIfContentfulCacheKey);

    if (legacyCacheEntries.length === 0) return;

    await AsyncStorage.multiRemove(legacyCacheEntries);
  } catch {}
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function checkIfContentfulCacheKey(key: string) {
  return key.startsWith(CONTENTFUL_CACHE_STORAGE_KEY);
}
